import {useEffect, useState} from 'react'
import {KTIcon} from "../../../../_metronic/helpers";
import axios from "axios";
import {toast} from "react-toastify";

const DisableModal = ({ data, onClose, fetchApiUsage }) => {
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    const disableAccess = async () => {
        try {
            setLoading(true)
            await axios.delete(`${process.env.REACT_APP_API_V3_URL}/partner/${data.partner_id}`);
            toast.success('Partners API access disabled successfully');
            await fetchApiUsage()
            onClose()
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Error while disabling partners API access');
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'
            >
                <div className={`modal-dialog modal-dialog-centered mw-550px`}>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h2 className='fw-bolder'>Are you sure you want to disable partners API access for {data.name}?</h2>
                            <div
                                className='btn btn-icon btn-sm btn-active-icon-primary'
                                data-kt-users-modal-action='close'
                                onClick={onClose}
                                style={{cursor: 'pointer'}}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>

                        <div className={`modal-body scroll-y mx-5  mx-xl-5`}>
                            <div
                                className="d-flex flex-column me-n7 pe-7"
                                style={{ height: 'auto', maxHeight: '380px' }}
                                id="kt_modal_add_user_scroll"
                                data-kt-scroll="true"
                                data-kt-scroll-activate="{default: false, lg: true}"
                                data-kt-scroll-max-height="auto"
                                data-kt-scroll-dependencies="#kt_modal_add_user_header"
                                data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                                data-kt-scroll-offset="300px"
                            >
                                <div className="text-center pt-5">
                                    <button
                                        type="reset"
                                        onClick={onClose}
                                        className="btn btn-light me-3"
                                        data-kt-users-modal-action="cancel"
                                        disabled={isLoading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn me-3 btn-danger"
                                        data-kt-users-modal-action="submit"
                                        onClick={disableAccess}
                                        disabled={isLoading}
                                    >
                                        <span className="indicator-label">Disable Access</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    )
}

export {DisableModal}
